import React from 'react'
import clsx from 'clsx'
import frameImage from '../../../src/images/Frame.png'
import './footer.scss'
import Icon from '../Icon/Icon'
import Heading from '../Heading/Heading'
import { Link } from 'gatsby'

export const Footer = ({ otherClasses }) => {
  const footerClasses = clsx(otherClasses, ' bg-black')
  return (
    <footer className={footerClasses} data-testid="footer">
      <div className="hidden  lg:flex flex-row justify-between  max-w-[1512px] xl:px-[120px] lg:px-[90px] mx-auto px-[35px] py-[48px]">
        <div className="space-y-[28.64px]">
          <img
            src={frameImage}
            alt="frameImage"
            className="w-[128px] h-[100.252px]"
          />

          <div className="justify-center gap-[20px] sm:flex hidden xl:flex">
            <a href="https://www.facebook.com/bayinktattoo">
              <Icon icon="facebook-icon" iconWidth={20} iconHeight={20} />
            </a>
            <a href="https://www.instagram.com/bayinktattoo/">
              <Icon icon="instagram-icon" iconWidth={20} iconHeight={20} />
            </a>
            <a href="https://www.tiktok.com/@bayinktattoogallery">
              <Icon icon="tiktok-icon" iconWidth={20} iconHeight={20} />
            </a>
          </div>
        </div>
        <div className="flex flex-col xl:items-start gap-4 ">
          <p className="text-[16px] font-bold font-Gentium-Plus leading-6 not-italic text-white">
            Explore
          </p>

          <ul className="text-[14px] font-normal font-Gentium-Plus leading-5 not-italic text-white opacity-70 flex flex-col gap-3">
            <li>
              <Link to="/tattoo-styles/">Tattoos</Link>
            </li>
            <li>
              <Link to="/piercing-services/">Piercings</Link>
            </li>
            <li>
              <Link to="/tattoo-artists/">Artists</Link>
            </li>
            <li>
              <Link to="/bay-ink-locations/">Studios</Link>
            </li>
            <li>
              <Link to="/buy-gift-card/">Gift Cards</Link>
            </li>
          </ul>
        </div>
        <div className="flex flex-col xl:items-start gap-4 ">
          <p className="text-[16px] font-bold font-Gentium-Plus leading-6 not-italic text-white">
            Resources
          </p>

          <ul className="text-[14px] font-normal font-Gentium-Plus leading-5  whitespace-nowrap not-italic text-white opacity-70 flex flex-col gap-3">
            <li>
              <Link to="/faq/">FAQs</Link>
            </li>
            <li>
              <Link to="/tattoo-aftercare/">Tattoo Aftercare</Link>
            </li>
            <li>
              <Link to="/piercing-aftercare/">Piercing Aftercare</Link>
            </li>
            <li>
              <Link to="/tattoo-piercing-blog/">Blog</Link>
            </li>
            <li>
              <Link to="/bay-ink-testimonials/">Reviews</Link>
            </li>
          </ul>
        </div>
        <div className="flex flex-col xl:items-start w-fit">
          <p className="text-[16px] font-bold font-Gentium-Plus leading-6 not-italic text-white mb-4">
            Bay Park
          </p>

          <ul className="text-[14px] font-normal font-Gentium-Plus leading-[1.0rem] not-italic text-white opacity-70 flex flex-col">
            <li className="leading-[24px]">
              2305 Morena Blvd <br /> San Diego, CA 92110
            </li>
            <a href="tel:619-359-4107">619-359-4107</a>
          </ul>
        </div>
        <div className="flex flex-col xl:items-start w-fit">
          <p className="text-[16px] font-bold font-Gentium-Plus not-italic text-white leading-6 mb-4">
            Hillcrest
          </p>

          <ul className="text-[14px] font-normal font-Gentium-Plus leading-[1.0rem] not-italic text-white opacity-70 flex flex-col">
            <li className="leading-[24px]">
              1050 University Ave #E103 <br /> San Diego, CA 92103
            </li>
            <a href="tel:619-310-6566">619-310-6566</a>
          </ul>
        </div>
        <div className="flex flex-col xl:items-start !gap-0  w-fit">
          <p className="text-[16px] font-bold font-Gentium-Plus not-italic text-white leading-6 mb-4">
            La Jolla
          </p>
          <ul className="text-[14px] object-scale-down font-normal font-Gentium-Plus leading-6 not-italic text-white gap-0 opacity-70 flex flex-col">
            <li className="leading-[24px]">
              7607 Girard Ave <br /> La Jolla, CA 92037
            </li>
            <a href="tel:858-352-6295">858-352-6295</a>
          </ul>
        </div>
      </div>
      <div className="block lg:hidden px-[35px] space-y-[48px] mb-[48px]">
        <div className="space-y-[28.64px]">
          <img
            src={frameImage}
            alt="frameImage"
            className="w-[128px] h-[100.252px]"
          />
        </div>
        <div className="grid grid-cols-2">
          <div className="space-y-[48px]">
            <div className="flex flex-col xl:items-start gap-4 ">
              <p className="text-[16px] font-bold font-Gentium-Plus leading-6 not-italic text-white">
                Explore
              </p>

              <ul className="text-[14px] font-normal font-Gentium-Plus leading-5 not-italic text-white opacity-70 flex flex-col gap-3">
                <li>
                  <Link to="/tattoo-styles/">Tattoos</Link>
                </li>
                <li>
                  <Link to="/piercing-services/">Piercings</Link>
                </li>
                <li>
                  <Link to="/tattoo-artists/">Artists</Link>
                </li>
                <li>
                  <Link to="/bay-ink-locations/">Studios</Link>
                </li>
                <li>
                  <Link to="/buy-gift-card/">Gift Cards</Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col xl:items-start gap-4 ">
              <p className="text-[16px] font-bold font-Gentium-Plus leading-6 not-italic text-white">
                Resources
              </p>

              <ul className="text-[14px] font-normal font-Gentium-Plus leading-5  whitespace-nowrap not-italic text-white opacity-70 flex flex-col gap-3">
                <li>
                  <Link to="/faq/">FAQs</Link>
                </li>
                <li>
                  <Link to="/tattoo-aftercare/">Tattoo Aftercare</Link>
                </li>
                <li>
                  <Link to="/piercing-aftercare/">Piercing Aftercare</Link>
                </li>
                <li>
                  <Link to="/tattoo-piercing-blog/">Blog</Link>
                </li>
                <li>
                  <Link to="/bay-ink-testimonials/">Reviews</Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col gap-[24px]">
              {/* <div className="flex flex-col xl:items-start gap-4">
                <div>
                  <p className="text-[16px] font-bold font-Roboto not-italic text-white leading-6 ">
                    Contact
                  </p>
                </div>
                <ul className="text-[14px] font-normal space-y-[24px] font-Roboto leading-6 not-italic text-white gap-0 opacity-70 ">
                  <li className="leading-[1.0rem]">
                    1300 Godward Street NESuite 6000Minneapolis, MN 55413
                  </li>
                  <li>
                    <a href="tel:1-888-509-2007">1 (888) 509-2007</a>
                  </li>
                  <li className="leading-[1.0rem]">advisors@tnma.com</li>
                </ul>
              </div> */}
              <div className="flex gap-[20px]">
                <a href="https://www.facebook.com/bayinktattoo">
                  <Icon icon="facebook-icon" iconWidth={20} iconHeight={20} />
                </a>
                <a href="https://www.instagram.com/bayinktattoo/">
                  <Icon icon="instagram-icon" iconWidth={20} iconHeight={20} />
                </a>
                <a href="https://www.tiktok.com/@bayinktattoogallery">
                  <Icon icon="tiktok-icon" iconWidth={20} iconHeight={20} />
                </a>
              </div>
            </div>
          </div>
          <div className="space-y-[24px]">
            <div className="flex flex-col xl:items-start w-fit">
              <p className="text-[16px] font-bold font-Gentium-Plus leading-6 not-italic text-white mb-4">
                Bay Park
              </p>

              <ul className="text-[14px] font-normal font-Gentium-Plus leading-[1.0rem] not-italic text-white opacity-70 flex flex-col space-y-[24px]">
                <li className="leading-[24px]">
                  2305 Morena Blvd <br /> San Diego, CA 92110
                </li>
                <a href="tel:619-359-4107">619-359-4107</a>
              </ul>
            </div>
            <div className="flex flex-col xl:items-start w-fit">
              <p className="text-[16px] font-bold font-Gentium-Plus not-italic text-white leading-6 mb-4">
                Hillcrest
              </p>

              <ul className="text-[14px] font-normal font-Gentium-Plus leading-[1.0rem] not-italic text-white opacity-70 flex flex-col space-y-[24px]">
                <li className="leading-[24px]">
                  1050 University Ave #E103 <br /> San Diego, CA 92103
                </li>
                <a href="tel:619-310-6566">619-310-6566</a>
              </ul>
            </div>
            <div className="flex flex-col xl:items-start !gap-0  w-fit">
              <p className="text-[16px] font-bold font-Gentium-Plus not-italic text-white leading-6 mb-4">
                La Jolla
              </p>
              <ul className="text-[14px] object-scale-down font-normal font-Gentium-Plus leading-6 not-italic text-white gap-0 opacity-70 flex flex-col space-y-[24px]">
                <li className="leading-[24px]">
                  7607 Girard Ave <br /> La Jolla, CA 92037
                </li>
                <a href="tel:858-352-6295">858-352-6295</a>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden  xl:block xl:w-full h-[1px] opacity-20 bg-white"></div>
      <div className="w-full mx-auto max-w-[1512px]  flex flex-col justify-center items-center xl:flex-row xl:justify-between sm:flex-row sm:justify-between px-20 xl:px-[100px] pb-[16px]">
        <div className="sm:flex-row sm:gap-4 flex flex-col xl:flex-row gap-3 xl:gap-4">
          <p className="text-[14px] font-normal  font-Gentium-Plus leading-5 not-italic text-white text-center">
            ©2023 Bay Ink Tattoo
          </p>
          <Link
            to="/privacy-policy/"
            className="text-[14px] font-normal  font-Gentium-Plus leading-5 not-italic text-white text-center"
          >
            Privacy Policy
          </Link>
        </div>
        <div className="flex py-5 gap-2 sm:gap-6 xl:gap-6">
          <Heading
            type="h2"
            className="text-[14px] font-normal font-Gentium-Plus leading-5 not-italic text-white  flex flex-col sm:gap-4 xl:gap-4 gap-3"
          >
            Powered by
          </Heading>
          <a
            href="https://www.wisedigitalpartners.com/nest-by-wise/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon
              icon="next-logo"
              iconWidth={'75.496px'}
              iconHeight={'20.001px'}
            />
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
